import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidePage from "../pages/vigorbuy-spreadsheet-guide/page";
import TemplatePage from "../pages/vigorbuy-spreadsheet-template/page";
import ReviewPage from "../pages/vigorbuy-spreadsheet-review/page";
import TutorialPage from "../pages/vigorbuy-spreadsheet-tutorial/page";
import SafetyPage from "../pages/vigorbuy-spreadsheet-safety/page";
import ComparisonPage from "../pages/vigorbuy-spreadsheet-comparison/page";
import BeginnerPage from "../pages/vigorbuy-spreadsheet-beginner/page";
import TipsPage from "../pages/vigorbuy-spreadsheet-tips/page";
import BusinessPage from "../pages/vigorbuy-spreadsheet-business/page";
import FeaturesPage from "../pages/vigorbuy-spreadsheet-features/page";
import ShoppingGuidePage from "../pages/vigorbuy-spreadsheet-shopping-guide/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/vigorbuy-spreadsheet-guide", element: <GuidePage /> },
  { path: "/vigorbuy-spreadsheet-template", element: <TemplatePage /> },
  { path: "/vigorbuy-spreadsheet-review", element: <ReviewPage /> },
  { path: "/vigorbuy-spreadsheet-tutorial", element: <TutorialPage /> },
  { path: "/vigorbuy-spreadsheet-safety", element: <SafetyPage /> },
  { path: "/vigorbuy-spreadsheet-comparison", element: <ComparisonPage /> },
  { path: "/vigorbuy-spreadsheet-beginner", element: <BeginnerPage /> },
  { path: "/vigorbuy-spreadsheet-tips", element: <TipsPage /> },
  { path: "/vigorbuy-spreadsheet-business", element: <BusinessPage /> },
  { path: "/vigorbuy-spreadsheet-features", element: <FeaturesPage /> },
  { path: "/vigorbuy-spreadsheet-shopping-guide", element: <ShoppingGuidePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;